import {
  USER_PRIVATE,
  USER_PUBLIC,
  UserPrivateRequest,
  UserPrivateResponse,
  UserPublicRequest,
  UserPublicResponse,
} from "@project/shared-types";
import apiFetchPost from "./apiClient";

export const GetUserPrivateAPI = async (dataRequest: UserPrivateRequest) => {
  try {
    const response = await apiFetchPost<
      UserPrivateRequest,
      UserPrivateResponse
    >(USER_PRIVATE, dataRequest);
    return response;
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
};

export const GetUserPublicAPI = async (dataRequest: UserPublicRequest) => {
  try {
    const response = await apiFetchPost<UserPublicRequest, UserPublicResponse>(
      USER_PUBLIC,
      dataRequest
    );
    return response;
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
};
